export default "__VITE_ASSET__01b0af7d__"